export default __webpack_public_path__ + "static/with-rocket-3fb54fcc8d2084f01e4354be403dc112.png";